<template>
  <InnerPageLayout>
    <section class="channels">
      <div class="wrap">
        <div class="bg_moon"></div>
        <div class="outside">
          <PageTitle>購買通路</PageTitle>
        </div>
        <div class="title_banner"></div>
        <div class="content">
          <PageTitle>購買通路</PageTitle>
          <AppSubtitle>實體通路</AppSubtitle>
          <div class="text">
            <WhereToBuyAccess>
              <div class="store">
                <div>
                  <p>PET 530ml</p>
                  <span
                    >全家、全聯、寶雅、美廉社、CitySuper、<br />唐吉訶德、家樂福、大潤發、愛買</span
                  >
                </div>
              </div>
            </WhereToBuyAccess>
            <WhereToBuyAccess>
              <div class="store">
                <div>
                  <p>鋁箔包 330ml</p>
                  <span>全聯</span>
                </div>
              </div>
            </WhereToBuyAccess>
            <WhereToBuyAccess>
              <div class="store">
                <div>
                  <p>PET 990ml</p>
                  <span>家樂福、大潤發、愛買、餐飲通路</span>
                </div>
              </div>
            </WhereToBuyAccess>
          </div>

          <AppSubtitle>線上通路</AppSubtitle>
          <div class="text">
            <div class="btns cannels_btns">
              <AppButton
                to="https://24h.pchome.com.tw/store/DBABI7"
                ga="whereToBuy-PChome-origin"
                :icon="false"
              >
                <span></span>
              </AppButton>
              <AppButton
                to="https://www.momoshop.com.tw/category/DgrpCategory.jsp?d_code=2000301165"
                ga="whereToBuy-momo-origin"
                :icon="false"
              >
                <span></span>
              </AppButton>
            </div>
          </div>

          <!-- <div class="btns">
            <AppButton :to="{ name: 'home' }" ga="whereToBuy-back-to-home">
              <span>返回首頁</span>
            </AppButton>
          </div> -->
        </div>
      </div>
    </section>
  </InnerPageLayout>
</template>

<script>
import InnerPageLayout from '@/layouts/InnerPageLayout';
import PageTitle from '@/components/PageTitle';
import AppSubtitle from '@/components/AppSubtitle';
import AppButton from '@/components/AppButton';
import WhereToBuyAccess from '@/components/WhereToBuyAccess';

export default {
  components: {
    InnerPageLayout,
    PageTitle,
    AppSubtitle,
    AppButton,
    WhereToBuyAccess,
  },
};
</script>

<style lang="scss">
@import './WhereToBuy.scss';
</style>
